import { VariantProps, cva } from 'class-variance-authority'
// https://ui.shadcn.com/docs/components/input
import { forwardRef } from 'react'

import { cn } from '@/utils/tw-helpers'

const inputVariants = cva(
  'flex w-full rounded-md placeholder:text-secondary-93 font-medium outline-none bg-white ring-offset-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-200 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 text-sm placeholder:text-sm text-primary-text',
  {
    variants: {
      variant: {
        default: 'border border-outline focus-visible:border-primary-100',
        plain: '',
      },
      size: {
        sm: 'h-[36px] px-2 py-1',
        md: 'h-[48px] px-[14px] py-2',
      },
      error: {
        true: 'border border-caution focus-visible:border-caution',
        false: '',
      },
    },
  }
)

export interface InputProps
  extends
    Omit<React.InputHTMLAttributes<HTMLInputElement>, 'size'>,
    VariantProps<typeof inputVariants> {}

const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, variant = 'default', size = 'md', type, error = false, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          inputVariants({
            variant,
            size,
            error,
            className,
          })
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = 'Input'

export { Input }
